import { Injectable } from '@angular/core';
import { TransactionDetailsFormatterService } from '@rd/core/services/transaction-details-formatter/transaction-details-formatter.service';
import { LoyaltyProgramHelper } from '@rd/helpers/loyalty-program.helper';
import { DynamicListItem } from '@rd/shared-legacy/components/dynamic-list/dynamic-list-item.type';
import {
  GiftCardPhysicalAddressFormData,
  LoyaltyProgram,
  PointsTransferMembership,
} from '@rd/types';

@Injectable()
export class AnzTransactionDetailsFormatterService extends TransactionDetailsFormatterService {
  constructor(loyaltyProgramHelper: LoyaltyProgramHelper) {
    super(loyaltyProgramHelper);
  }

  physicalGcRecipientDetailsFormat(
    address: GiftCardPhysicalAddressFormData,
  ): DynamicListItem[] {
    const details = super.physicalGcRecipientDetailsFormat(address);
    details.push({ value: 'Australia', cssClass: 'country' });
    return details;
  }

  pointsTransferDetailsFormat(params: {
    loyaltyProgram: LoyaltyProgram;
    pointsTransferData: Partial<PointsTransferMembership>;
    processingDelay: number;
  }): DynamicListItem[] {
    const { loyaltyProgram, pointsTransferData, processingDelay } = params;
    return [
      {
        translationKey:
          'wl.anz.transfer_v2.review.membership_title_with_delay_time',
        htmlTag: 'p',
        cssClass: 'membership-details-title',
        value: {
          loyaltyCurrency: loyaltyProgram.loyaltyCurrency?.name ?? '',
          processingDelay:
            this.loyaltyProgramHelper.transferTime(processingDelay),
        },
      },
      {
        translationKey: loyaltyProgram.name,
        htmlTag: 'p',
        cssClass: 'font-semibold',
      },
      {
        translationKey: `${pointsTransferData.firstName} ${pointsTransferData.lastName}`,
        htmlTag: 'p',
        cssClass: 'membership-details-information',
      },
      {
        translationKey: pointsTransferData.number,
        htmlTag: 'p',
        cssClass: 'membership-details-information',
      },
    ];
  }
}
